// import CryptoJS from 'crypto-js'
const signRequest = (config) => {
  /* no body md5 now
  var bodyMd5 = ''
  if (config.data !== undefined) {
    var jsonBody = (typeof config.data !== 'string' ? JSON.stringify(config.data) : config.data)
    bodyMd5 = CryptoJS.MD5(jsonBody)
  } else {
    config.data = ''
  }
  */
  config.headers['X-Timestamp'] = config.headers['X-Timestamp'] || (new Date()).toISOString()

  /* skip signature for now
  var urlObj = document.createElement('a')

  urlObj.href = config.url

  var path = (urlObj.pathname.indexOf('/') === 0) ? urlObj.pathname : '/' + urlObj.pathname

  config.method = config.method.toUpperCase().trim()

  var stringToSign = '' +
    config.method + '\n' +
    bodyMd5 + '\n' +
    (config.headers['Content-Type'] || '') + '\n' +
    'x-timestamp:' + config.headers['X-Timestamp'] + '\n' +
    path

  var signatureWordArray = CryptoJS.enc.Utf8.parse(stringToSign)

  var secret = [229, 198, 213, 25, 88, 218, 189, 65, 141, 247, 229, 202, 135, 234, 102, 229]

  var secretWordArray = byteArrayToWordArray(secret)

  var signature = CryptoJS.HmacSHA1(signatureWordArray, secretWordArray).toString(CryptoJS.enc.Base64)

  console.log(signature)
  */

  config.headers['Authorization'] = 'application ' + '1325b8bb-e84d-4e9e-9919-dd61392f175d'
}
/* not used right now
function byteArrayToWordArray (ba) {
  var wa = []
  var i
  for (i = 0; i < ba.length; i++) {
    wa[(i / 4) | 0] |= ba[i] << (24 - 8 * i)
  }

  return CryptoJS.lib.WordArray.create(wa, ba.length)
}
*/
export {
  signRequest
}



// WEBPACK FOOTER //
// ./src/api/routing/authorization.js